import { type IYachtSetupForm } from "./YachtSetup.types";
import { bool } from "yup";

export const mapYachtSetup = (response: any) => {
  const data = response.data.content.data;
  return {
    yachtid: response._yachtid,
    yacht: data.yachtname,
    imo: data.data.imo,
    mmsi: data.data.mmsi,
    callsign: data.data.sign,
    ofnum: data.data.num,
    gton: data.data.gross,
    nton: data.data.net,
    flag: data.data.flag,
    port: data.data.port,
    len: data.data.len,
    dnl: data.data.dnl ? `${data.data.dnl}` : "",
    lblang: data.data.lblang,
    vtype: data.data.vtype,
    vtypeother: data.data.vtypeother,
    iom: data.data.iom,
    ballastCapacity: data.data.ballastCapacity,
    uppercase: data.data.uppercase as boolean,
  };
};

export const vesselParticularsFields: Array<{
  name?: keyof IYachtSetupForm;
  line?: boolean;
  label?: string;
  type?: string;
}> = [
  { name: "yacht", label: "Yacht Name" },
  { name: "imo", label: "IMO" },
  { name: "mmsi", label: "MMSI" },
  { name: "callsign", label: "Call Sign" },
  { name: "ofnum", label: "Official Number" },
  { name: "gton", label: "Gross Tonage" },
  { name: "nton", label: "Net Tonage" },
  { name: "flag", label: "Flag" },
  { name: "port", label: "Port Of Registry" },
  { name: "len", label: "Registered Length" },
  { name: "dnl", label: "Distinctive Numbers or Letters" },
  { name: "ballastCapacity", label: "Total Ballast Water Capacity m³" },
];
